import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const TracesIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG viewBox={`0 0 ${props.height ?? 19} ${props.width ?? 19}`} {...props} fill="none">
      <path
        d="M15.2951 7.91649H3.71298C2.54132 7.91649 1.59131 6.95858 1.59131 5.79483V3.71274C1.59131 2.54107 2.54923 1.59106 3.71298 1.59106H15.2951C16.4667 1.59106 17.4167 2.54899 17.4167 3.71274V5.79483C17.4167 6.95858 16.4588 7.91649 15.2951 7.91649Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2951 17.4165H3.71298C2.54132 17.4165 1.59131 16.4586 1.59131 15.2948V13.2127C1.59131 12.0411 2.54923 11.0911 3.71298 11.0911H15.2951C16.4667 11.0911 17.4167 12.049 17.4167 13.2127V15.2948C17.4167 16.4586 16.4588 17.4165 15.2951 17.4165Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.75 3.95728V5.54061" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.91614 3.95728V5.54061" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4.75 13.4573V15.0406" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.91614 13.4573V15.0406" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.0839 4.75H14.2505" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.0839 14.25H14.2505" strokeLinecap="round" strokeLinejoin="round" />
    </BaseSVG>
  )
}
